// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"7ec940dc","462":"f0dea882","498":"39fed883","716":"5b744b63","851":"1abe137f","935":"8b51094d","990":"c6aaae42","994":"af5e3b6b"}[chunkId] + ".chunk.js";
};